import { render, staticRenderFns } from "./EventRegisterButtons.vue?vue&type=template&id=7f76408e&"
import script from "./EventRegisterButtons.vue?vue&type=script&lang=js&"
export * from "./EventRegisterButtons.vue?vue&type=script&lang=js&"
import style0 from "./EventRegisterButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports